import { formatDimensionCm } from './formatters';
import { MUSEUM_LABEL_THEME_VARS } from './museumLabelThemes';

// Normalise user selections so we can safely look up a predefined theme.
export function normalizeMuseumLabelPreviewKey(labelKey) {
  if (!labelKey) {
    return null;
  }

  const trimmed = String(labelKey).trim().toLowerCase();

  if (!trimmed || trimmed === 'none') {
    return null;
  }

  const underscored = trimmed.replace(/[^a-z0-9]+/g, '_');

  if (Object.prototype.hasOwnProperty.call(MUSEUM_LABEL_THEME_VARS, underscored)) {
    return underscored;
  }

  if (Object.prototype.hasOwnProperty.call(MUSEUM_LABEL_THEME_VARS, trimmed)) {
    return trimmed;
  }

  return 'white';
}

// Retrieve the CSS variables that theme the label.
export function getMuseumLabelThemeVars(labelKey) {
  if (!labelKey) {
    return null;
  }

  return MUSEUM_LABEL_THEME_VARS[labelKey] || MUSEUM_LABEL_THEME_VARS.white;
}

// Assemble the data object consumed by the label modal and inline preview.
export function buildMuseumLabelData({
  artworkData,
  selectedEntry,
  widthCm,
  heightCm,
  normalizedMuseumLabelKey,
}) {
  if (!selectedEntry || !normalizedMuseumLabelKey) {
    return null;
  }

  const rawTitle = typeof artworkData?.title === 'string' ? artworkData.title.trim() : '';
  const rawArtist = typeof artworkData?.artist_name === 'string' ? artworkData.artist_name.trim() : '';
  const rawYear = artworkData?.year ? String(artworkData.year).trim() : null;
  const rawMedium = typeof artworkData?.medium === 'string' ? artworkData.medium.trim() : null;
  const location = typeof artworkData?.location === 'string' ? artworkData.location.trim() : '';
  const series = typeof artworkData?.series === 'string' ? artworkData.series.trim() : '';

  const widthLabel = formatDimensionCm(selectedEntry?.width ?? widthCm);
  const heightLabel = formatDimensionCm(selectedEntry?.height ?? heightCm);
  const size = widthLabel && heightLabel ? `${widthLabel} × ${heightLabel} cm` : null;
  const edition = selectedEntry?.quantity ? `Edition of ${selectedEntry.quantity}` : null;
  const extras = location || series || null;

  const title = rawTitle || 'Untitled';
  const artist = rawArtist || null;
  const artistLine = [artist, rawYear].filter(Boolean).join(', ') || null;

  return {
    title,
    artist,
    artistLine,
    year: rawYear,
    medium: rawMedium,
    size,
    edition,
    extras,
    theme: normalizedMuseumLabelKey,
  };
}
